import { Divider as HeroUiDivider } from '@heroui/divider';

export const Divider = HeroUiDivider;
